
 <template>
  <div class="">
    <div class="ccui-top-title">运输方式</div>
    <el-form ref="form1" label-width="100px" class="ccui-form">
      <el-form-item
        label="运输方式："
        :label-width="labelwidth"
        class="el-form-item-text"
      >
        <span class="el-form-text">
          {{ cateName }}
        </span>
      </el-form-item>
    </el-form>
    <div style="padding: 10px;"></div>
    <div class="ccui-top-title">线路信息</div>
    <el-form ref="form" label-width="100px" class="ccui-form">
      <el-form-item
        label="线路列表："
        :label-width="labelwidth"
        class="el-form-item-sku-list"
      >
        <el-table :data="routeData" border :fit="true" style="width: 100%">
          <el-table-column type="index" label="序号" align="center" width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="起运地" align="center" width="280">
            <template slot-scope="scope">
              {{ scope.row.originProvinceName }}
              {{ scope.row.originCityName }}
            </template>
          </el-table-column>
          <el-table-column label="目的地" align="center" width="280">
            <template slot-scope="scope">
              {{ scope.row.destinationProvinceName }}
              {{ scope.row.destinationCityName }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item
        label="车型列表："
        v-if="showPropNames === 1"
        :label-width="labelwidth"
        class="el-form-item-sku-list"
      >
        <span class="el-form-table">
          <el-table :data="skuList" border :fit="true" style="width: 100%">
            <el-table-column prop="routeObj" label="线路" width="250">
              <template slot-scope="scope">
                <div
                  class="road-text-box"
                  :title="
                    scope.row.routeObj.originProvinceName +
                    ' ' +
                    scope.row.routeObj.originCityName +
                    '-' +
                    scope.row.routeObj.destinationProvinceName +
                    ' ' +
                    scope.row.routeObj.destinationCityName
                  "
                >
                  {{ scope.row.routeObj.originProvinceName }}
                  {{ scope.row.routeObj.originCityName }}
                  -
                  {{ scope.row.routeObj.destinationProvinceName }}
                  {{ scope.row.routeObj.destinationCityName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-for="item in propNames"
              :key="item.propNameId"
              :prop="item.propNameId"
              :label="item.propName"
              width="100"
            >
              <template slot-scope="scope">
                {{ scope.row[item.propNameId] }}
              </template>
            </el-table-column>
            <el-table-column prop="skuMats" label="运输货物类型" width="150">
              <template slot-scope="scope">
                <el-tooltip effect="dark" placement="right">
                  <div slot="content">
                    <p
                      style="padding: 2px 0"
                      v-for="item in scope.row.skuMats"
                      :key="item.matCode"
                    >
                      {{ item.matName }}
                    </p>
                  </div>
                  <div>
                    <p
                      class="ellipsis"
                      v-for="(item, index) in scope.row.skuMats"
                      :key="item.matCode"
                      v-show="index <= 5"
                    >
                      {{ item.matName }}
                    </p>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="unitName" label="单位" width="60" />
            <el-table-column prop="minSaleCount" label="起运量" width="60" />
            <el-table-column prop="taxCode" label="税控编码" width="180" />
            <el-table-column prop="taxInfo" label="税率" width="110" />
            <el-table-column prop="stockNum" label="车辆数量" width="110" />
            <el-table-column
              prop="salePrice"
              label="参考价（元）"
              align="right"
              width="110"
            >
              <template slot-scope="scope">
                ￥{{ myPrice(scope.row.salePrice) }}
              </template>
            </el-table-column>
          </el-table>
        </span>
      </el-form-item>
      <el-form-item
        label="创建时间："
        :label-width="labelwidth"
        class="el-form-item-text"
      >
        <span class="el-form-text-clamp">{{ createTime }}</span>
      </el-form-item>
      <!-- <el-form-item
            label="适用区域："
            :label-width="labelwidth"
            class="el-form-item-text"
          >
            <span class="el-form-text-clamp">{{ applyArea }}</span>
          </el-form-item> -->
    </el-form>
    <div style="padding: 10px;"></div>
    <div class="ccui-top-title">基本信息</div>
    <el-form ref="form" label-width="100px" class="ccui-form">
      <el-form-item
        label="路线标题："
        prop="spuTitle"
        :label-width="labelwidth"
        class="el-form-item-text"
      >
        <span class="el-form-text">
          {{ goodsInfo.spuTitle }}
        </span>
      </el-form-item>
      <el-form-item
        label="路线标语："
        prop="spuPromo"
        :label-width="labelwidth"
        class="el-form-item-text"
      >
        <span class="el-form-text">
          {{ goodsInfo.spuPromo }}
        </span>
      </el-form-item>
      <el-form-item
        label="路线关键字："
        prop="skuKeyWords"
        :label-width="labelwidth"
        class="el-form-item-text"
      >
        <span class="el-form-text">
          {{ skuKeyWords }}
        </span>
      </el-form-item>
      <el-form-item
        v-for="(item1, index1) of goodsInfo.pictureRspBOS"
        :key="index1"
        :label="
          item1.propNameJoin ? item1.propNameJoin + `：` : '路线图片' + `：`
        "
        prop="pictureRspBOS"
        :label-width="labelwidth"
        class="el-form-item-imgul"
      >
        <ul class="" style="display: flex; flex-wrap: wrap">
          <li
            v-for="(item, index) of item1.pictures"
            :key="index"
            style="display: flex; flex-direction: column; align-items: center"
          >
            <img
              :src="item.url"
              style="width: 80px; height: 80px; padding: 10px"
            />
            <span v-if="index === 0">路线主图</span>
          </li>
        </ul>
      </el-form-item>
      <el-form-item
        label="路线介绍："
        prop="detailPc"
        :label-width="labelwidth"
        class="el-form-item-richtext detailPc"
      >
        <span class="el-form-text goods-detail-produce">电脑端描述</span>
        <div v-html="goodsInfo.detailPc"></div>
      </el-form-item>
      <!-- <el-form-item
            label="路线介绍："
            prop="detailPhone"
            :label-width="labelwidth"
            class="el-form-item-richtext detailPc"
          >
            <span class="el-form-text goods-detail-produce">手机端描述</span>
            <div v-html="goodsInfo.detailPhone"></div>
          </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import { numberFilter } from "@/utils/index.js";
import {
  queryCreatingLogisticsCommodity,
  queryBaseInfo,
  queryLogisticsSaleInfo,
  queryGoodInfoAndSaleAfter,
} from "@/views/lessor-open-shop/api.js";
export default {
  name: "lineInfo",
  data() {
    return {
      skuKeyWords: "",
      labelwidth: "100px",
      cateName: "",
      createTime: "",
      showPropNames: 0,
      spuId: "",
      goodsInfo: {
        detailPc: "",
        pictureRspBOS: [],
      },
      routeData: [],
      skuList: [],
      propNames: [],
      applyArea: "", //适用区域
      saleInfoOther: {
        unitName: "", //计量单位
        salePrice: "", //销售价
        marketPrice: "", //市场价
        jietiPrice: [], //阶梯价
        stockNum: "", //库存数量
        weight: "", //毛重
        upcCode: "", //路线条形码
        extSkuId: "", //商家编码
        taxCode: "", //税控编码
        goodsName: "", //货物名称
        maxSaleCount: "", //单次最大销售量
        supplier: "", //供货商
      },
      putawayTimer: "", // 定时上架时间
      isPutawayTimer: "", // 是否定时上架
      isSoldoutTimer: "", // 是否定时下架
      soldoutTimer: "", // 定时下架时间
      goodsInfo: {
        //路线信息
        spuTitle: "",
        spuPromo: "",
        detailPc: "",
        detailPhone: "",
        pictureRspBOS: [],
      },
    };
  },
  mounted() {},
  methods: {
    setData(val) {
      if (val.spuId) {
        this.spuId = val.spuId;
        this.getQueryBaseInfo(); // 基本属性以及审批记录
        this.getQuerySaleInfo(); // 销售属性
        this.getQueryGoodInfoAndSaleAfter(); // 路线信息以及售后服务信息
      }

      // queryCreatingLogisticsCommodity({
      //   shopId: val.shopId,
      // }).then((res) => {
      //   const da = res.data.data;
      //   if (da.exists) {
      //     this.spuId = da.spuId;
      //     this.getQueryBaseInfo(); // 基本属性以及审批记录
      //     this.getQuerySaleInfo(); // 销售属性
      //     this.getQueryGoodInfoAndSaleAfter(); // 路线信息以及售后服务信息
      //   }
      // });
    },

    async getQueryBaseInfo() {
      let obj = {
        flag: 1, //1-仅查看   2-编辑查看
        isShowLoading: true,
        shopId: this.$route.query.shopId,
        spuId: this.spuId,
      };
      await queryBaseInfo(obj)
        .then((res) => {
          if (res.data.code === "0") {
            this.skuKeyWords = res.data.data.skuKeyWords;
            this.cateName = res.data.data.classifyNamePath;
            // this.baseInfolist = res.data.data.skuProps;
            this.createTime = res.data.data.spuLogisticsBO.createTime;
            // this.approvalLogId = res.data.data.approvalLogId;

            // res.data.data.skuProps.forEach((item) => {
            //   let arr = [];
            //   item.propValues.forEach((obj) => {
            //     if (item.propEditClassify === 5) {
            //       if (obj.choose) {
            //         arr.push(obj.propValue);
            //       }
            //     } else {
            //       arr.push(obj.propValue);
            //     }
            //   });
            //   item.checkedProps = arr.join("、");
            // });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getQuerySaleInfo() {
      let obj = {
        flag: 1, //1-仅查看   2-编辑查看
        isShowLoading: true,
        shopId: this.$route.query.shopId,
        spuId: this.spuId,
      };
      queryLogisticsSaleInfo(obj)
        .then((res) => {
          if (res.data.code === "0") {
            const { showPropNames, spuLogisticsBO } = res.data.data;
            this.showPropNames = showPropNames;

            this.routeData = spuLogisticsBO;
            this.propNames =
              res.data.data.propNames && res.data.data.propNames.length > 0
                ? res.data.data.propNames
                : []; //路线销售属性
            this.applyArea =
              typeof res.data.data.applyArea === "object"
                ? res.data.data.applyArea.address
                : ""; // 适用区域
            this.saleInfoOther =
              res.data.data.skus && res.data.data.skus.length > 0
                ? res.data.data.skus[0]
                : [];
            this.skuList = res.data.data.skus.map((item) => {
              // 组装动态属性
              const classifyProps = {};
              Object.entries(item.carPropData).forEach((n) => {
                const options = res.data.data.propNames.find(
                  (j) => j.propNameId === n[0]
                );
                const value = options.propValues.find(
                  (j) => j.propValueId === n[1]
                );
                classifyProps[n[0]] = value.propValue;
              });
              return {
                routeObj: spuLogisticsBO.find((n) => n.spuId === item.spuId),
                ...classifyProps,
                ...item,
              };
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getQueryGoodInfoAndSaleAfter() {
      let obj = {
        flag: 1, //1-仅查看   2-编辑查看
        isShowLoading: true,
        shopId: this.$route.query.shopId,
        spuId: this.spuId,
      };
      queryGoodInfoAndSaleAfter(obj)
        .then((res) => {
          /**/
          if (res.data.code === "0") {
            this.isPutawayTimer = res.data.data.goodInfo.isPutawayTimer;
            this.putawayTimer =
              res.data.data.goodInfo.putawayTimer &&
              res.data.data.goodInfo.putawayTimer.substring(0, 16);
            this.isSoldoutTimer = res.data.data.goodInfo.isSoldoutTimer;
            this.soldoutTimer =
              res.data.data.goodInfo.soldoutTimer &&
              res.data.data.goodInfo.soldoutTimer.substring(0, 16);

            this.goodsInfo.spuTitle = res.data.data.goodInfo.spuTitle;
            this.goodsInfo.spuPromo = res.data.data.goodInfo.spuPromo;
            this.goodsInfo.detailPc = res.data.data.goodInfo.detailPc;
            this.goodsInfo.detailPhone = res.data.data.goodInfo.detailPhone;
            let pictureRspBOS = res.data.data.goodInfo.pictureRspBOS;
            this.goodsInfo.pictureRspBOS =
              pictureRspBOS && pictureRspBOS.length > 0 ? pictureRspBOS : [];
            /**给第一条进行排序**/
            this.goodsInfo.pictureRspBOS[0].pictures.sort(function (a, b) {
              return b.picType - a.picType;
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    myPrice(num) {
      let num1 = numberFilter(num);
      return num1.newNum;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.white-space {
  white-space: pre-wrap;
}
/deep/ .goods-detail-produce {
  max-width: 980px;
  display: inline-block;
  /*overflow-x: auto;*/
}
/deep/ .detailPc {
  .el-form-item__content {
    overflow-x: auto;
  }
  img {
    max-width: 100%;
  }
}
.title-message {
  display: block;
  font-size: 13px;
  color: #9b9b9b;
  margin-left: 94px;
  margin-top: 20px;
  line-height: 23px;
  border-bottom: 0;
  font-weight: 400;
}
.tipRight {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  vertical-align: middle;
  > span {
    display: flex;
    align-items: flex-end;
    > img {
      width: 21px;
      height: 23px;
    }
  }
}
.road-text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 22px;
  line-height: 22px;
}

// 超出长度...
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.cate-title {
  background: #fff;
  padding: 14px 21px;
  margin-top: 16px;
  font-size: 13px;
  color: #4a4a4a;
  &:after {
    display: table;
    clear: both;
    content: "";
  }
  p {
    float: left;
    min-height: 28px;
    line-height: 28px;
  }
  .default-button {
    float: left;
    margin-left: 68px;
  }
}
/deep/.ccui-app-container-detail-head2 {
  height: auto;
}
.overNone {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 5;
  text-overflow: ellipsis;
}
</style>

